import type { ProfessionalStatus } from '@medely/types';

export const HISTORICAL_JOB_STATUSES = [
  'clocked_out',
  'canceled_with_fee',
  'completed',
  'disputed',
  'no_show',
  'held_for_dispute_review',
  'late_cancellation',
  'missed_shift',
];

export const NON_HISTORICAL_JOB_STATUSES = ['clocked_in', 'booked', 'active'];

export const ONBOARDING_RESTRICTED_STATUSES: ProfessionalStatus[] = [
  'deactivated',
  'limited_access',
  'limited_access_reinstatement',
  'paused',
  'paused_requirement_submitted',
];
